import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAtomValue } from 'jotai';
import { isNullish } from 'remeda';

import { userAtom } from 'v2/atoms/userAtom';
import { UserRole } from 'v2/constants';
import { AppRoute } from 'v2/routes';
import { isRouteAllowed } from 'v2/utils';

interface RoleGuardProps {
  group: UserRole[];
}

export const RoleGuard: FC<PropsWithChildren<RoleGuardProps>> = ({ group, children }) => {
  const user = useAtomValue(userAtom);

  if (isNullish(user)) {
    return null;
  }

  return isRouteAllowed(user.roles, group) ? children : <Navigate to={AppRoute.FORBIDDEN} />;
};
